import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AgIcon from "./commons/AgIcon";

const styles = {
    root: {
        textAlign: 'right',
        marginLeft: 'auto',
        alignSelf: 'center'
    },
};

const Clock = ({classes, date, time, ...props}) => {
    return (
        <div className={classes.root}>
            <Typography variant={'body2'}>{date} <AgIcon icon='calendar' size={12}/></Typography>
            <Typography variant={'body2'}>{time} <AgIcon icon='clock' size={12}/></Typography>
        </div>
    );
};

Clock.propTypes = {

};

export default withStyles(styles)(Clock);
